/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPlaidAccessDetailsForCustomer} from '../api'

 export const useQueryGetPlaidAccessDetailsForCustomer = createReactQueryHook('getPlaidAccessDetailsForCustomer', getPlaidAccessDetailsForCustomer)
